export const uiHelper = (_) => {
  const PENDING = "PENDING";
  const CONFIRMED = "CONFIRMED";
  const REJECTED = "REJECTED";

  let ui = {
    showEditBtn: false,
    showCancelBtn: false,
    showDeleteBtn: false,
    showMaskLayer: false,
    mainInfoText: '',
    detailInfoText: '',
    data: {},
    modifiedApi: false
  };

  //1
  if (_?.status === PENDING && _?.modified === null) {
    ui.showEditBtn = true;
    ui.showDeleteBtn = true;
    ui.showMaskLayer = true;
    ui.mainInfoText = 'محتوا در انتظار بررسی و تایید است'
    ui.data = _;
    return ui;
  }

  //2
  if (_?.status === CONFIRMED && _?.modified === null) {
    ui.showEditBtn = true;
    ui.showDeleteBtn = true;
    ui.data = _;
    return ui;
  }

  //3
  if (_?.status === CONFIRMED && _?.modified?.status === PENDING) {
    ui.showCancelBtn = true;
    ui.showMaskLayer = true;
    ui.mainInfoText = 'تغییرات شما در حال بررسی است و تا 24 ساعت آینده اعمال خواهد شد'
    ui.data = _?.modified;
    ui.modifiedApi = true;
    return ui;
  }

  //4
  if (_?.status === REJECTED && _?.modified === null) {
    ui.showEditBtn = true;
    ui.showDeleteBtn = true;
    ui.showMaskLayer = true;
    ui.mainInfoText = 'محتوا تایید نشد';
    ui.detailInfoText = `علت: ${_?.records[0]?.comments[0]?.comment}`
    ui.data = _;
    return ui;
  }

  //5
  if (_?.status === CONFIRMED && _?.modified?.status === REJECTED) {
    ui.showEditBtn = true;
    ui.showCancelBtn = true;
    ui.showMaskLayer = true;
    ui.mainInfoText = 'برخی از تغییرات شما توسط کارشناسان رد شد';
    ui.detailInfoText = `علت: ${_?.records[0]?.comments[0]?.comment}`
    ui.data = _?.modified;
    ui.modifiedApi = true;
    return ui;
  }

  return ui;
};
